var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "md-layout",
        [
          _c(
            "md-switch",
            {
              staticClass: "md-primary",
              model: {
                value: _vm.ads.banner.enabled,
                callback: function($$v) {
                  _vm.$set(_vm.ads.banner, "enabled", $$v)
                },
                expression: "ads.banner.enabled"
              }
            },
            [_vm._v("Use Banner Image")]
          )
        ],
        1
      ),
      _vm.ads.banner.enabled
        ? _c(
            "md-layout",
            [
              _c(
                "md-input-container",
                {
                  class: {
                    "md-input-invalid":
                      _vm.formSubmitted && _vm.validations.banner.image.$invalid
                  }
                },
                [
                  _c("label", [_vm._v("Image URL")]),
                  _c("md-input", {
                    model: {
                      value: _vm.ads.banner.image,
                      callback: function($$v) {
                        _vm.$set(_vm.ads.banner, "image", $$v)
                      },
                      expression: "ads.banner.image"
                    }
                  }),
                  _vm.formSubmitted && _vm.validations.banner.image.$invalid
                    ? _c("span", { staticClass: "md-error" }, [
                        _vm._v("Invalid URL")
                      ])
                    : _vm._e()
                ],
                1
              ),
              _c(
                "md-input-container",
                {
                  class: {
                    "md-input-invalid":
                      _vm.formSubmitted && _vm.validations.banner.link.$invalid
                  }
                },
                [
                  _c("label", [_vm._v("Link URL")]),
                  _c("md-input", {
                    model: {
                      value: _vm.ads.banner.link,
                      callback: function($$v) {
                        _vm.$set(_vm.ads.banner, "link", $$v)
                      },
                      expression: "ads.banner.link"
                    }
                  }),
                  _vm.formSubmitted && _vm.validations.banner.link.$invalid
                    ? _c("span", { staticClass: "md-error" }, [
                        _vm._v("Invalid URL")
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6eac612d", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eac612d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/ImageBanner.vue
// module id = 761
// module chunks = 0